import { useNavigate } from "react-router-dom";
import HolidayScheduleButton from "../../components/HolidayScheduleButton";
import HolidayScheduleStatusBadge from "../../components/HolidayScheduleStatusBadge";
import { useHolidaySchedule } from "../../contexts/HolidayScheduleContext";
import { Heading, Subheading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableHeader,
} from "../../design/table";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import EmptyStateView from "../../components/EmptyStateView";
import { Button } from "../../design/button";
import { PlusIcon } from "@heroicons/react/20/solid";
import { useCreateHolidayScheduleDialog } from "../../providers/CreateHolidayScheduleDialogProvider";

const HolidayScheduleListPage = () => {
  const { openDialog } = useCreateHolidayScheduleDialog();
  const { holidaySchedules, loading, error } = useHolidaySchedule();
  const navigate = useNavigate();

  if (loading.list) {
    return <LoadingView title="Loading Holiday Schedules..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Heading>Holiday Schedules</Heading>
        <Button onClick={() => openDialog()}>
          <PlusIcon className="w-4 h-4" />
          <span>Create Holiday Schedule</span>
        </Button>
      </div>
      {holidaySchedules.length === 0 ? (
        <EmptyStateView
          title="No Holiday Schedules"
          message="No holiday schedules found. Create a holiday schedule to get started."
          action={
            <HolidayScheduleButton
              onSave={(id) => navigate(`/holiday-schedule/${id}`)}
            />
          }
        />
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader className="w-1/3">Schedule</TableHeader>
              <TableHeader className="w-1/3">Status</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {holidaySchedules.map((schedule) => (
              <TableRow
                key={schedule._id}
                href={`/holiday-schedule/${schedule._id}`}
              >
                <TableCell>
                  <Subheading>{schedule.name}</Subheading>
                </TableCell>
                <TableCell>
                  <HolidayScheduleStatusBadge status={schedule.status} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default HolidayScheduleListPage;
